<template>
  <section class="pay-result">
    <top-header class="page-top-header" :showLogin="false"></top-header>
    <div class="result-info-container">
      <PayState
        v-if="result == SUCCESS"
        class="result-type-wrapper"
        :tips="letter.storeSuccessTips"
        :title="letter.v3PaymentSuccess"
        state="success"
      >
        <!-- 双倍券结果提示语 -->
        <template v-if="productRemark === 'SpecialParamWithDoubleSend'">
          <p class="opera-tips">{{ letter.doubleSendInfo }}</p>
        </template>
      </PayState>
      <PayState
        v-if="result == WAITING"
        class="result-type-wrapper"
        :tips="letter.storeSuccessTips"
        :title="letter.storeAcceptance"
        state="storing"
      ></PayState>
      <PayState
        v-if="result == FAIL"
        class="result-type-wrapper"
        :tips="letter.v3TopUpFailureMessage"
        :title="letter.v3PaymentFailure"
        state="fail"
      ></PayState>
      <div class="order-info-wrapper">
        <div class="order-info-bg"></div>
        <div class="order-info-container">
          <div class="pay-info flex-center">
            <span class="bold" v-if="isCart">
              {{ cartPriceAmount }}
              <span v-if="isShowTax && !hasUseCoupon">
                {{ `+ ${curTax} ${currency}(tax)` }}
              </span>
            </span>
            <span class="bold" v-else-if="hasUseCoupon">
              {{ amountDesc }}
              <span v-if="isShowTax && !hasUseCoupon">
                {{ `+ ${curTax} ${currency}(tax)` }}
              </span>
            </span>
            <span class="bold" v-else>
              <template v-if="isJpPlatform">
                {{ priceAmount }}
              </template>
              <template v-else>
                {{ `${amount}${currency}` }}
                <span v-if="isShowTax">
                  {{ `+ ${curTax} ${currency}(tax)` }}
                </span>
              </template>
            </span>
          </div>
          <div class="order-container">
            <div class="order-info-list">
              <span class="floatL">{{ letter.creatework_game }}</span>
              <span class="floatR bold">{{ gameName }}</span>
            </div>
            <div class="order-info-list">
              <span class="floatL">UID：</span>
              <span class="floatR bold">{{ userId || uid }}</span>
            </div>
            <div class="order-info-list">
              <span class="floatL">{{ letter.orderNumber }}：</span>
              <span class="floatR bold">{{ orderId }}</span>
            </div>
            <div class="order-info-list">
              <template v-if="isCart">
                <template v-if="+totalQuantity">
                  <span class="floatL">{{ letter.buyProduct }}：</span>
                  <span class="floatR look-detail" @click="lookOrderRecord">{{
                    letter.look_detail_of_cart
                  }}</span>
                  <span class="floatR bold">{{
                    letter.total_n_product.replace('${n}', totalQuantity)
                  }}</span>
                </template>
              </template>
              <template v-else>
                <span class="floatL">{{ letter.buyProduct }}：</span>
                <span class="floatR bold">{{ payResult }}</span>
              </template>
            </div>
            <div class="order-info-list" v-if="hasUseCoupon">
              <span class="floatL">{{ letter.couponCoupon }}：</span>
              <Mark class="floatR bold bigMark">
                {{ couponInfoName }}
              </Mark>
            </div>
            <div class="order-info-list" v-if="hasUseCoupon">
              <span class="floatL">{{ letter.transactionAmount }}：</span>
              <Mark class="floatR bold bigMark">
                {{ discountAfterAmount }}
                <span v-if="isShowTax">
                  {{ `+ ${curTax} ${currency}(tax)` }}
                </span>
              </Mark>
            </div>
            <div class="order-info-list" v-if="result == FAIL">
              <span class="floatL">{{ letter.failReason }}：</span>
              <span class="floatR bold middleMark pay-errmsg">
                {{ msg }}
              </span>
            </div>
            <pwa-install-home
              v-if="isShowPwa"
              :isResultPage="true"
              :location="2"
            ></pwa-install-home>
            <p class="opera-tips">{{ letter.screenshotTips }}</p>
            <template v-if="result == SUCCESS && showQuickPayTip">
              <div class="opera-tips">
                <p>
                  {{ letter.quickcard_result_tip_one }}
                </p>
                <p>
                  {{ letter.quickcard_result_tip_two }}
                </p>
                <p class="look-more mb0" @click="isShowQuickPayPopup = true">
                  {{ letter.quickcard_learn_more }}
                </p>
              </div>
            </template>
            <div class="follow-operation flex-center" v-if="result == SUCCESS">
              <!-- 再储值一笔 -->
              <Button
                class="follow-operation-btn restore"
                pointClass="j-restore-btn"
                @click="reStore"
              >
                {{ letter.payOntherORder }}
              </Button>
            </div>
            <div class="follow-operation flex-center" v-if="result == WAITING">
              <!-- 再储值一笔 -->
              <Button
                class="follow-operation-btn restore"
                pointClass="j-restore-btn"
                @click="reStore"
                :loading="loading"
              >
                {{ letter.payOntherORder }}
              </Button>
            </div>
            <div class="follow-operation" v-if="result == FAIL">
              <Button
                class="follow-operation-btn contact-us"
                @click="showFeebackPage"
                pointClass="j-go-feeback-btn"
                v-if="!uidGame && needServiceBtn"
              >
                {{ letter.contactService }}
              </Button>
              <Button
                class="follow-operation-btn"
                pointClass="j-restore-btn"
                @click="reStore"
              >
                {{ letter.reStore }}
              </Button>
            </div>
          </div>
        </div>
      </div>
      <!-- 结算页banner -->
      <div
        class="order-banner order-banner-swiper swiper-container"
        :key="lang"
        v-if="showBannerList.length > 0"
      >
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in showBannerList"
            :key="index"
          >
            <img
              :src="item.bannerUrl"
              class="order-banner-image j-order-banner"
              :pointValue="item.redirectUrl"
              alt="order-banner-image"
              @click="bannerClick(item.redirectUrl)"
            />
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>

    <form v-bind:action="postAction" method="post">
      <input
        type="hidden"
        name="cardType"
        v-bind:value="post_fields.cardType"
      />
      <input
        type="hidden"
        name="gatewayNo"
        v-bind:value="post_fields.gatewayNo"
      />
      <input
        type="hidden"
        name="goodsInfo"
        v-bind:value="post_fields.goodsInfo"
      />
      <input type="hidden" name="merNo" v-bind:value="post_fields.merNo" />
      <input
        type="hidden"
        name="notifyUrl"
        v-bind:value="post_fields.notifyUrl"
      />
      <input
        type="hidden"
        name="orderAmount"
        v-bind:value="post_fields.orderAmount"
      />
      <input
        type="hidden"
        name="orderCurrency"
        v-bind:value="post_fields.orderCurrency"
      />
      <input type="hidden" name="orderNo" v-bind:value="post_fields.orderNo" />
      <input type="hidden" name="remark" v-bind:value="post_fields.remark" />
      <input
        type="hidden"
        name="returnUrl"
        v-bind:value="post_fields.returnUrl"
      />
      <input
        type="hidden"
        name="shopperId"
        v-bind:value="post_fields.shopperId"
      />
      <input
        type="hidden"
        name="signInfo"
        v-bind:value="post_fields.signInfo"
      />
      <input type="hidden" name="token" v-bind:value="post_fields.token" />
      <input
        type="hidden"
        name="verifyBillingAddress"
        v-bind:value="post_fields.verifyBillingAddress"
      />
      <button type="submit" id="postOrderToBank" class="hide"></button>
    </form>
    <transition name="fade" mode="out-in">
      <QuickPayCardPopup
        @close="isShowQuickPayPopup = false"
        v-if="isShowQuickPayPopup"
        :languages="letter"
      ></QuickPayCardPopup>
    </transition>
    <transition name="fade" mode="out-in">
      <CartOrderRecord
        :coinName="coinName"
        :currency="currency"
        :cartList="cartList"
        :cartTotalProductExtraCoin="cartTotalProductExtraCoin"
        v-if="isShowOrderRecord"
        @close="isShowOrderRecord = false"
      ></CartOrderRecord>
    </transition>
    <transition name="fade" mode="out-in">
      <Loading v-show="apiLoading"></Loading>
    </transition>
  </section>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import Swiper from 'swiper';

import PayState from '@components/officialTopupNew/paytype/PayState.vue';
import TopHeader from '@components/officialTopupNew/TopHeader.vue';
import QuickPayCardPopup from '@components/officialTopupNew/paytype/QuickPayCardPopup.vue';
import CartOrderRecord from '@components/officialTopupNew/cart/CartOrderRecord.vue';
import Loading from '@components/officialTopupNew/Loading.vue';

import globalConfig from '@utiles/officialStore/globalConfig';
import { b64DecodeUnicode, changePriceFormat } from '@utiles/officialStore';
import bridge from '@utiles/officialStore/bridge';
import {
  locationType,
  clickButton,
  viewPage,
  pageType
} from '@plugins/biPoint/_configWebstoreV35';
import { UPDATE_GAMEID } from '@store/officialTopupNew';
import { GET_CART } from '@store/officialTopupNew/cart';
import { GET_ACTIVITY_LIST } from '@store/officialTopupNew/activity';
import { getWebviewPageFlag } from '@store/officialTopupNew/storager';
import contactService from '@mixins/officialTopupNew/contactService';
import { sdkOpenLink } from '@utiles/officialStore/sdkCtrl';
import { commonEmitUpload } from '../../plugins/AnalyzePoint/index';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
import PwaInstallHome from '@components/officialTopupNew/pwa/PwaInstallHome.vue';
const mainHost = globalConfig.getMainHost();
let gameId =
  globalConfig.getHrefParam('gameId') ||
  globalConfig.getHrefParam('gameID') ||
  globalConfig.getHrefParam('game_id') ||
  '';
export default {
  name: 'resultPage',
  mixins: [contactService],
  data() {
    let store_url_params = decodeURIComponent(
      globalConfig.getHrefParam('store_url_params').replace('#/result', '')
    );
    let storeParams = b64DecodeUnicode(store_url_params);
    let postOrderParams = {};
    const webviewEnv = getWebviewPageFlag() == 1;
    try {
      postOrderParams = JSON.parse(storeParams);
    } catch (e) {
      console.error(e);
    }

    return {
      swiper: null,
      uidGame: globalConfig.isUidGame(),
      needServiceBtn: postOrderParams['hideService'] != 1,
      result: globalConfig.getHrefParam('result'),
      msg: globalConfig.getHrefParam('msg'),
      gameId: gameId,
      sid: globalConfig.getHrefParam('server_sid'),
      serverId: globalConfig.getHrefParam('server_id'),
      orderId: globalConfig.getHrefParam('order_id'),
      coin: globalConfig.getHrefParam('coin'),
      sub_coin: globalConfig.getHrefParam('sub_coin'),
      extra_coin: globalConfig.getHrefParam('extra_coin'),
      coinName: globalConfig.getHrefParam('coin_name'),
      mode: postOrderParams['mode'],
      userId: postOrderParams['userId'] ? postOrderParams['userId'] : '',
      SUCCESS: 1,
      FAIL: 0,
      WAITING: 2,
      postOrderParams,
      webviewEnv,
      postAction: '',
      post_fields: {},
      pageSource: postOrderParams['pageSource'],
      roleId: postOrderParams['roleId'],
      roleName: postOrderParams['roleName'],
      packageName: postOrderParams['packageName'],
      productRemark: postOrderParams['productRemark'],
      loading: false,
      showQuickPayTip:
        postOrderParams['f_pay_type'] === 'world_pay' ||
        (postOrderParams['f_pay_type'] === 'alipay' &&
          postOrderParams['pay_type'] &&
          postOrderParams['pay_type'].toLowerCase().indexOf('card') === 0),
      isShowQuickPayPopup: false,
      isUidLogin: postOrderParams['isUidLogin'] == '1',
      uid: postOrderParams['uid'] ? postOrderParams['uid'] : '',
      loginAccount: postOrderParams['loginAccount'],
      isCart: postOrderParams['submitType'] == '1',
      cartList: [],
      isShowOrderRecord: false,
      currency: postOrderParams['currency'],
      hasUseCoupon: postOrderParams['couponId'],
      couponInfoName: postOrderParams['couponInfoName'],
      discountAfterAmount: postOrderParams['discountAfterAmount'],
      cid: postOrderParams['cid'] ? postOrderParams['cid'] : '',
      scid: postOrderParams['scid'] ? postOrderParams['scid'] : '',
      productType: postOrderParams['productType']
        ? postOrderParams['productType']
        : '',
      productId: postOrderParams['productId']
        ? postOrderParams['productId']
        : '',
      cpProductId: postOrderParams['cpProductId']
        ? postOrderParams['cpProductId']
        : '',
      amount: postOrderParams['amount'] ? postOrderParams['amount'] : '',
      fPayType: postOrderParams['f_pay_type']
        ? postOrderParams['f_pay_type']
        : '',
      paytype: postOrderParams['paytype'] ? postOrderParams['paytype'] : '',
      priceSubCoinName: postOrderParams['priceSubCoinName']
        ? postOrderParams['priceSubCoinName']
        : '', // 渠道拆单道具名称
      priceExtraCoinName: postOrderParams['priceExtraCoinName']
        ? postOrderParams['priceExtraCoinName']
        : '', // 渠道加码道具名称
      productExtraCoin: postOrderParams['productExtraCoin']
        ? postOrderParams['productExtraCoin']
        : '', // 开发商加码PRODUCT_EXTRA_COIN
      productExtraCoinName: postOrderParams['productExtraCoinName']
        ? postOrderParams['productExtraCoinName']
        : '', // 开发商加码道具名称
      curTax: postOrderParams['curTax'] || 0,
      location: postOrderParams['location'] || '',
      cartTotalProductExtraCoin:
        Number(postOrderParams['cartTotalProductExtraCoin']) || 0
    };
  },
  beforeCreate() {
    viewPage(pageType.resultPage);
    this.$store.commit(UPDATE_GAMEID, gameId);
  },
  created() {
    this.sendResultBiData();
    if (this.isCart) {
      this.getCart();
    }
  },
  computed: {
    ...mapState({
      isCoinsSubmitType: state => state.isCoinsSubmitType,
      apiLoading: state => state.loading,
      lang: state => state.lang,
      payBannerList: state => state.activity.payBannerList,
      isLandscape: state => state.page.isLandscape
    }),

    ...mapGetters(['isJpPlatform']),
    gameName() {
      return globalConfig.getHrefParam('game_name');
    },
    payResult() {
      let illegalPay = globalConfig.getHrefParam('illegal_pay') * 1;
      let transAmount = globalConfig.getHrefParam('trans_amount');
      let desc = this.postOrderParams && this.postOrderParams.productDesc;
      // 非点卡默认显示
      if (!transAmount) {
        return desc;
      }

      // sub_coin不为0说明为拆单情况
      if (+this.sub_coin && this.coinName && transAmount * 1 > 0) {
        let desArray = [this.sub_coin + ' ' + this.priceSubCoinName];
        if (this.extra_coin && this.extra_coin * 1 > 0) {
          desArray.push(this.extra_coin + ' ' + this.priceExtraCoinName);
        }
        /**
         *  illegalPay为1指点卡小买大，显示【渠道拆单内容+渠道加码内容】
         *  不为1说明大买小，显示【商品名 + 开发商加码PRODUCT_EXTRA_COIN + 渠道拆单内容 + 渠道加码内容 】
         */
        if (illegalPay === 1) {
          return desArray.join(` ${this.letter.and || 'and'} `);
        } else {
          // 有开发商加码，则拼接上
          if (+this.productExtraCoin) {
            // 2024.5.29 运营需求: 庄恺杰 特殊处理371ROV首充赠送水晶名称
            if (+this.gameId === 371) {
              desArray.unshift(this.productExtraCoin + ' Crystals');
            } else {
              desArray.unshift(
                this.productExtraCoin + ' ' + this.productExtraCoinName
              );
            }
          }
          return desc.replace(
            /\s((\d*)|(\d*\.\d*))\s.*$/,
            ' ' + desArray.join(` ${this.letter.and || 'and'} `)
          );
        }
      }
      return desc;
    },
    letter() {
      return this.$store.state.letter;
    },
    isShowPwa() {
      return (
        this.gameId == 191 &&
        !this.showBannerList.length &&
        !this.isLandscape &&
        !bridge.runInsdk()
      );
    },
    priceAmount() {
      let currency = globalConfig.getHrefParam('currency');
      let transAmount = globalConfig.getHrefParam('trans_amount');
      if (currency && transAmount) {
        return changePriceFormat(currency, transAmount) + ' ' + currency;
      } else {
        // 日本平台固定写死单位：JPY
        let postCurrency = this.isJpPlatform
          ? 'JPY'
          : this.postOrderParams && this.postOrderParams.currency;
        let amountDesc =
          this.postOrderParams && this.postOrderParams.amountDesc;
        return changePriceFormat(postCurrency, amountDesc) + ' ' + postCurrency;
      }
    },
    cartPriceAmount() {
      let postCurrency = this.postOrderParams && this.postOrderParams.currency;
      let amountDesc = this.postOrderParams && this.postOrderParams.amount;
      return changePriceFormat(postCurrency, amountDesc) + ' ' + postCurrency;
    },
    amountDesc() {
      // 日本平台固定写死单位：JPY
      let postCurrency = this.isJpPlatform
        ? 'JPY'
        : this.postOrderParams && this.postOrderParams.currency;
      let amountDesc = this.postOrderParams && this.postOrderParams.amountDesc;
      return changePriceFormat(postCurrency, amountDesc) + ' ' + postCurrency;
    },
    isShowTax() {
      return +this.curTax > 0 && this.location === 'US';
    },
    totalQuantity() {
      let totalQuantity = 0;
      this.cartList.forEach(item => {
        totalQuantity += +item.quantity;
      });
      return totalQuantity;
    },
    showBannerList() {
      // 判断列表每个banner.basic?.bannerUrl不为空的情况，合成一个新数组
      const list = [];
      this.payBannerList.forEach(item => {
        if (item?.basic?.bannerUrl) {
          list.push(item?.basic);
        }
      });
      return list;
    }
  },
  methods: {
    sendResultBiData() {
      window.webstorev35DataLayer.push({
        eventName: 'payment_result',
        uid: this.uid,
        loginAccount: this.loginAccount || '',
        roleId: this.roleId || '',
        roleName: this.roleName || '',
        serverId: this.serverId,
        cid: this.cid,
        scid: this.scid,
        eventValue: {
          result: this.result,
          product_type: this.productType || '',
          cp_product_id: this.cpProductId,
          product_id: this.productId,
          product_num: '1',
          product_currency: this.currency,
          product_money: this.amount,
          local_currency: this.currency,
          local_money: this.amount,
          f_pay_type: this.fPayType,
          pay_type: this.paytype,
          order_id: this.orderId,
          ...this.postOrderParams?.biCouponInfo,
          uid: this.uid,
          loginAccount: this.loginAccount || '',
          roleId: this.roleId || '',
          roleName: this.roleName || '',
          serverId: this.serverId,
          cid: this.cid,
          scid: this.scid
        }
      });
    },
    backGame() {
      bridge.callSdkMethod('closeWebview');
    },
    showFeebackPage() {
      clickButton({
        btnName: 'contact_service',
        locationKey: locationType.resultPage
      });
      if (this.isJpPlatform) {
        this.jpService({
          gameId: this.gameId,
          pcServerId: this.sid,
          roleId: this.roleId,
          roleName: this.roleName,
          uid: this.uid
        });
        return;
      }
      this.openGlobalService({
        gameId: this.gameId,
        roleId: this.roleId,
        roleName: this.roleName,
        serverId: this.sid,
        isUidLogin: this.isUidLogin,
        uid: this.uid,
        loginAccount: this.loginAccount
      });
    },
    reStore() {
      clickButton({
        btnName: 're_store',
        locationKey: locationType.resultPage
      });
      this.loading = true;
      if (this.isJpPlatform) {
        const hostName = window.location.hostname;
        const firstHost = hostName.split('.')[0];
        //全球平台日本平台域名兼容
        if (process.env.NODE_ENV !== 'production') {
          window.location.href = getGlobalGetGotoLink({
            link: `https://gabres.${mainHost}/officialTopupNew.html?gameId=${this.gameId}&cid=${this.cid}&scid=${this.scid}&roleId=${this.roleId}&serverId=${this.sid}&mode=${this.mode}`
          });
        } else {
          if (firstHost === 'pay') {
            window.location.href = getGlobalGetGotoLink({
              link: `https://pay.${mainHost}/platform/officialTopupNew.html?gameId=${this.gameId}&cid=${this.cid}&scid=${this.scid}&roleId=${this.roleId}&serverId=${this.sid}&mode=${this.mode}`
            });
          } else {
            window.location.href = getGlobalGetGotoLink({
              link: `https://jpstore.${window.atob(
                'MzdnYW1lcy5jb20='
              )}/mobile/signin?gameId=${this.gameId}&cid=${this.cid}&scid=${
                this.scid
              }&roleId=${this.roleId}&serverId=${this.sid}&mode=${this.mode}`
            });
          }
        }
      } else {
        window.location.href =
          process.env.NODE_ENV !== 'production'
            ? getGlobalGetGotoLink({
                link: `https://gabres.${mainHost}/officialTopupNew.html?gameId=${this.gameId}&cid=${this.cid}&scid=${this.scid}&roleId=${this.roleId}&serverId=${this.sid}&mode=${this.mode}`
              })
            : getGlobalGetGotoLink({
                link: `https://pay.${mainHost}/platform/officialTopupNew.html?gameId=${this.gameId}&cid=${this.cid}&scid=${this.scid}&roleId=${this.roleId}&serverId=${this.sid}&mode=${this.mode}`
              });
      }
    },
    lookOrderRecord() {
      this.isShowOrderRecord = true;
      const dataEvent = {
        0: 'click-fail-cart-look-detail',
        1: 'click-succ-cart-look-detail',
        2: 'click-wait-cart-look-detail'
      };
      commonEmitUpload(dataEvent[+this.result], {
        event: dataEvent[+this.result],
        newPage: false,
        type: 'click'
      });
    },
    getCart() {
      this.$store
        .dispatch(GET_CART, this.orderId)
        .then(res => {
          this.cartList = res;
        })
        .catch(err => {
          console.log('cart err', err);
        });
    },
    initSwiper() {
      try {
        const isMulti = this.showBannerList.length > 1;
        this.swiper && this.swiper.destroy();
        this.swiper = new Swiper('.order-banner-swiper', {
          loop: isMulti,
          autoplay: {
            delay: 4000
          },
          direction: 'horizontal',
          pagination: isMulti
            ? {
                el: '.swiper-pagination',
                clickable: true
              }
            : false,
          effect: 'slide'
        });
      } catch (err) {
        console.error(err);
      }
    },
    bannerClick(link) {
      sdkOpenLink({
        link: getGlobalGetGotoLink({ link: link })
      });
    }
  },
  watch: {
    // 活动是根据语言参数接口由接口处理多语言，所以语言变化时需要重新获取活动列表
    lang: {
      immediate: true,
      handler(newVal) {
        if (!newVal) return;
        this.$store.dispatch(GET_ACTIVITY_LIST, {
          pos: ['pay_banner']
        });
      }
    },
    showBannerList: {
      handler(newVal) {
        if (!newVal.length) return;
        this.$nextTick(() => {
          this.initSwiper();
        });
      }
    }
  },
  components: {
    PayState,
    QuickPayCardPopup,
    CartOrderRecord,
    Loading,
    TopHeader,
    PwaInstallHome
  }
};
</script>
<style lang="scss" scoped>
@import '@assets/scss/officialTopupNew/officialTopupNew.scss';
@import '@assets/scss/officialTopupNew/_dimen.scss';

.pay-result {
  position: relative;
  background: $backgroundColor;
  min-height: 100%;
}
.page-top-header {
  position: sticky;
}
.result-info-container {
  position: relative;
  padding: 0 20px;
}
.order-info-wrapper {
  position: relative;
  margin: 45px auto;
  width: 100%;
  max-width: 670px;

  .order-info-bg {
    background: url($commonImg + 'result-bg.png') no-repeat;
    background-size: 100% auto;
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .order-info-container {
    position: relative;
    margin: 0 auto;
    font-size: 22px;
    color: #333333;
    border-radius: 20px;
  }
  .pay-info {
    position: relative;
    height: 159px;
    font-size: 38px;
  }

  .order-container {
    margin-top: 30px;
    box-sizing: border-box;
    padding: 0 23px;
    background-color: #ffffff;
    border-radius: 0 0 20px 20px;
    .order-info-list {
      display: inline-block;
      width: 100%;
      line-height: 1.5;
      margin: 17px 0;
      .floatL {
        font-size: 24px;
        color: #999999;
      }
      .floatR {
        font-size: 24px;
      }
    }
  }
}
.follow-operation {
  box-sizing: border-box;
  padding: 0 0 40px;
  margin-top: 36px;
  display: flex;
  flex-direction: column;

  .follow-operation-btn {
    width: 100%;
    height: 59px;
    font-size: 26px;
    color: #fff;
    border-radius: 9px;
    cursor: pointer;
    padding: 0 30px;
    background: $themeColor;
    &.contact-us {
      background: #ffffff;
      border: 1px solid $themeColor;
      color: $themeColor;
      cursor: pointer;
    }
  }
  .follow-operation-btn + .follow-operation-btn {
    margin-top: 20px;
  }
}
.look-detail {
  margin-left: 10px;
  cursor: pointer;
  text-decoration: underline;
  color: #b07d1a;
}
.opera-tips {
  margin-top: 60px;
  box-sizing: border-box;
  padding: 0 20px;
  position: relative;
  line-height: 1.5;
  text-align: center;
  font-size: 22px;
  color: #333333;
  .look-more {
    cursor: pointer;
    color: #b07d1a;
  }
}

.order-banner {
  width: 100%;
  max-width: 670px;
  padding-bottom: 40px;
  margin: 0 auto;
  &-image {
    cursor: pointer;
    width: 100%;
  }
}
.middleMark {
  color: #f56a57;
}
.bigMark {
  font-size: 36px;
}
.bold {
  font-weight: bold;
}
.pay-errmsg {
  display: inline-block;
  max-width: 100%;
  word-break: break-word;
}

.banner-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.swiper-pagination {
  box-sizing: border-box;
  padding: 0 40px;
  text-align: right;
  bottom: 21px;
}
#ssr-page.landscape {
  .result-info-container {
    width: 750px;
    margin: 0 auto;
  }
}
</style>
